import { render, staticRenderFns } from "./UndoGlyphModal.vue?vue&type=template&id=070fe22a&scoped=true"
import script from "./UndoGlyphModal.vue?vue&type=script&lang=js"
export * from "./UndoGlyphModal.vue?vue&type=script&lang=js"
import style0 from "./UndoGlyphModal.vue?vue&type=style&index=0&id=070fe22a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070fe22a",
  null
  
)

export default component.exports